'use client';
import React, { useState } from 'react';
import { CheckCircle, AlertCircle, Info, Check } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const initialNotifications = [
  { id: 1, type: 'success', title: 'Booking Confirmed', message: 'Your Ganesh Puja on Aug 7 at 9:00 AM has been confirmed.', time: '2 min ago', read: false },
  { id: 2, type: 'info', title: 'Priest Assigned', message: 'Pandit Ramesh Kumar has been assigned to your Ganesh Puja booking.', time: '1 hr ago', read: false },
  { id: 3, type: 'alert', title: 'Reminder', message: 'Satyanarayana Puja is scheduled for Aug 15. Please ensure the venue is ready.', time: '3 hrs ago', read: false },
  { id: 4, type: 'info', title: 'New Ritual Available', message: 'Navgraha Shanti Puja is now available in your city. Book early for auspicious dates.', time: '1 day ago', read: true },
  { id: 5, type: 'success', title: 'Payment Received', message: 'Payment of ₹4,500 received for Navgraha Shanti Puja (ID: YGN-2026-P001).', time: '2 days ago', read: true },
  { id: 6, type: 'success', title: 'Review Reminder', message: 'How was your Lakshmi Puja experience? Leave a review for Pandit Ramesh Kumar.', time: '5 days ago', read: true },
];

const typeConfig = {
  success: { icon: CheckCircle, color: 'text-green-500', bg: 'bg-green-50' },
  info: { icon: Info, color: 'text-saffron', bg: 'bg-saffron/10' },
  alert: { icon: AlertCircle, color: 'text-amber-500', bg: 'bg-amber-50' },
};

export default function Notifications() {
  const [notifications, setNotifications] = useState(initialNotifications);

  const markAllRead = () => setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  const markRead = (id: number) => setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));

  const unread = notifications.filter(n => !n.read).length;

  return (
    <div className="space-y-5 max-w-2xl">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-display text-xl font-bold text-maroon">Notifications</h2>
          <p className="text-sm text-maroon/50 mt-0.5">{unread} unread</p>
        </div>
        {unread > 0 && (
          <button
            onClick={markAllRead}
            className="flex items-center gap-1.5 text-xs font-semibold text-saffron border border-saffron/30 px-3 py-1.5 rounded-full hover:bg-saffron/5 transition-colors"
          >
            <Check size={12} /> Mark all read
          </button>
        )}
      </div>

      <div className="bg-white rounded-2xl border border-gold/15 overflow-hidden divide-y divide-gold/10">
        {notifications.map((notif) => {
          const config = typeConfig[notif.type as keyof typeof typeConfig];
          const Icon = config.icon;
          return (
            <div
              key={notif.id}
              onClick={() => markRead(notif.id)}
              className={`px-5 py-4 flex items-start gap-3.5 cursor-pointer hover:bg-cream/30 transition-colors ${!notif.read ? 'bg-amber-50/40' : ''}`}
            >
              <div className={`w-8 h-8 rounded-full ${config.bg} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                <Icon size={15} className={config.color} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <p className={`text-sm font-semibold ${!notif.read ? 'text-maroon' : 'text-maroon/70'}`}>{notif.title}</p>
                  {!notif.read && <div className="w-2 h-2 rounded-full bg-saffron flex-shrink-0 mt-1.5" />}
                </div>
                <p className="text-xs text-maroon/55 mt-0.5 leading-relaxed">{notif.message}</p>
                <p className="text-[10px] text-maroon/35 mt-1.5">{notif.time}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
